module.exports = __webpack_public_path__ + "img/subscriptions.39b226b5.svg";